import { Loader, Paper, Text } from "@mantine/core"
import { useQuery } from "@tanstack/react-query"
import { createFileRoute } from "@tanstack/react-router"

import { queries } from "@/lib/queries"

export const Route = createFileRoute("/hub/ic-meetings")({
  component: IcMeetings,
})

function IcMeetings() {
  const { data, isPending } = useQuery(queries.icMeetings())

  return (
    <Paper withBorder p="lg" radius={0} style={{ borderColor: "var(--pitch-border)" }}>
      {isPending ? (
        <Loader size="sm" />
      ) : !data || data.length === 0 ? (
        <Text c="var(--pitch-text-tertiary)">No IC meeting records available yet.</Text>
      ) : (
        <Text c="var(--pitch-text-primary)">IC Meetings — {data.length} records</Text>
      )}
    </Paper>
  )
}
